import React, { useCallback, useMemo } from 'react';
import {
  ChallengeDetails,
  Container,
  CountUsers,
  Footer,
  ImageChallenge,
  SeasonDetails,
} from './styles';
import PrimaryButton from '../Buttons/PrimaryButton';
import {
  RoundCheckIcon,
  SpinnerIcon,
  SubmissionIcon,
  UsersIcon2,
} from '../../assets/svg/SVGComponents';
import { useModal } from '../../hooks/modal';
import ChallengeDetailsModal from '../../modals/ChallengeDetailsModal';
import IChallengeDataProps from '../../dtos/IChallengeDataProps';

const ChallengeCard: React.FC<IChallengeDataProps> = ({
  id,
  slug,
  illustration_url,
  title,
  description,
  start_submission,
  end_submission,
  count_submissions,
  status,
}) => {
  const { handleModal } = useModal();

  const formattedSubmissionTime = useMemo(() => {
    const startDate = new Date(start_submission);
    const endDate = new Date(end_submission);

    // Formata as datas para dd/MM
    const formattedStart = startDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });

    const formattedEnd = endDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const daysRemaining = Math.ceil(
      (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24),
    );

    const statusMessage =
      daysRemaining <= 0
        ? 'Último dia'
        : `faltam ${daysRemaining} dia${daysRemaining !== 1 ? 's' : ' '}`;

    return `Período: ${formattedStart} a ${formattedEnd} • ${statusMessage}`;
  }, [end_submission, start_submission]);

  const buttonProps = useMemo(() => {
    switch (status) {
      case 'no_submit':
        return {
          label: 'Participar',
          icon: <SubmissionIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FF9800', // Laranja
        };
      case 'submited':
        return {
          label: 'Participando',
          icon: <SpinnerIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FFA726', // Laranja mais claro
        };
      case 'completed':
        return {
          label: 'Concluído',
          icon: <RoundCheckIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#4CAF50', // Verde
        };
      default:
        return {
          label: 'Participar',
          icon: <SubmissionIcon width="1rem" strokeWidth={2} stroke="#fff" />,
          bgColor: '#FF9800',
        };
    }
  }, [status]);

  const handleModalOpen = useCallback(() => {
    handleModal(
      <ChallengeDetailsModal
        id={id}
        slug={slug}
        illustration_url={illustration_url}
        title={title}
        description={description}
        start_submission={start_submission}
        end_submission={end_submission}
        count_submissions={count_submissions}
        status={status}
      />,
      {
        pathname: '/challenges',
        state: {
          'modal-type': 'chalenge',
        },
      },
    );
  }, [
    count_submissions,
    description,
    end_submission,
    handleModal,
    id,
    illustration_url,
    slug,
    start_submission,
    status,
    title,
  ]);

  return (
    <Container>
      <button type="button" onClick={() => handleModalOpen()}>
        <ImageChallenge src={illustration_url} alt="image-default" />
        <ChallengeDetails>
          <h1>{title}</h1>
          <SeasonDetails>
            <p>{formattedSubmissionTime}</p>
          </SeasonDetails>
          <Footer>
            <PrimaryButton
              onClick={() => handleModalOpen()}
              style={{ backgroundColor: buttonProps.bgColor }}
            >
              {buttonProps.icon}
              {buttonProps.label}
            </PrimaryButton>
            <CountUsers>
              <UsersIcon2 width="1rem" strokeWidth={2} stroke="#1e88e5" />
              {count_submissions}
            </CountUsers>
          </Footer>
        </ChallengeDetails>
      </button>
    </Container>
  );
};

export default ChallengeCard;
